import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import Item from './components/Item';
import {
	IScheduleViewContext,
	ScheduleViewContext,
} from '../../scheduleViewContext/scheduleViewState/scheduleViewContext';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import { availablePushScheduleForClientManager, availablePushScheduleForRestaurantManager } from 'appConstants';
import classNames from 'classnames';
import style from './ScheduleList.module.scss';

const ScheduleList: React.FC = () => {
	const { scheduledPushes } = useContext<IScheduleViewContext>(ScheduleViewContext);
	const hasFullAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);
	const hasClientManagerAccess = useRoleAccess([UserRoles.CLIENT_MANAGER, UserRoles.GROUP_MANAGER]);
	const hasRestaurantManagerAccess = useRoleAccess([UserRoles.RESTAURANT_MANAGER]);

	const pushesHeadingClasses = classNames(style.pushes, style.heading);
	const statusHeadingClasses = classNames(style.status, style.heading);
	const dateTimeHeadingClasses = classNames(style.dateTime, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div data-test="UpdateHistoryList">
			<div className={style.tableHeaders}>
				<Text
					className={pushesHeadingClasses}
					translationNameSpace="form"
					translationKey="pushesLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={statusHeadingClasses}
					translationNameSpace="form"
					translationKey="statusLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={dateTimeHeadingClasses}
					translationNameSpace="form"
					translationKey="dateTimeLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="form"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{scheduledPushes.pushNotifications.map((item, index) => {
				if (hasFullAccess) {
					return <Item data={item} key={item.id} index={index} />;
				}
				if (hasClientManagerAccess && availablePushScheduleForClientManager.includes(item.type)) {
					return <Item data={item} key={item.id} index={index} />;
				}
				if (hasRestaurantManagerAccess && availablePushScheduleForRestaurantManager.includes(item.type)) {
					return <Item data={item} key={item.id} index={index} />;
				}
			})}
		</div>
	);
};

export default ScheduleList;
